require("./visualcomparison.scss");


window.addEventListener("load", () => {

	$('[data-role="gallery"]').slick({
		dots: true,
		customPaging: function (slider, i) {
			return '<button type="button" role="tab"  data-webm-clickvalue="carousel-dots-visual-comparison"></button>';
		},
		prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"  aria-disabled="false"  data-webm-clickvalue="carousel-prev-visual-comparison">PREVIOUS</button>',
		nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"  aria-disabled="false"  data-webm-clickvalue="carousel-next-visual-comparison">NEXT</button>',

		infinite: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					arrows: false,
					dots: true

				}
			}
		]
	});

	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		$('[data-role="gallery"]').slick('setPosition');
	});
});